import React, { useState } from 'react'
import "./Contact.css"
import Contact_card from './contact_card/Contact_card'
import Contact_form from './contact_form/Contact_form'
import ScrollToTop from '../../ScrollTotop/ScrollTotop'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import Breadcrumb_comp from '../../common/breadcrumb-comp/Breadcrumb_comp'
import Common_title from '../../common/common-title/Common_title'

function Contact() {
    const [showMap, setShowMap] = useState(false);
    const [mapAnimation, setMapAnimation] = useState(""); // control animation class

    const handleClick = () => {
        setShowMap(true);
        setMapAnimation("scale-up-ver-bottom");
    };

    const handleCloseMap = () => {
        // Start scale-down animation
        setMapAnimation("scale-down-ver-bottom");

        // Wait for animation to complete (500ms typical for CSS)
        setTimeout(() => {
            setShowMap(false);
        }); // Adjust duration to match CSS animation time
    };
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "CONTACT US", link: "", isActive: true },
    ];

    return (
        <>
            <section className='Contact margin_section'>
                <div className="container">

                    {!showMap && (
                        <>
                            <Breadcrumb_comp breadcrumbs={breadcrumbs} />

                            <Common_title
                                title={"CAMPUS DEAL "}
                                subtitle={"Let's Get in Touch"}
                            />

                            <Contact_card />

                            <Contact_form mapOnClick={handleClick} />
                        </>
                    )}


                    {showMap && (
                        <>
                            <ScrollToTop />


                            <div className={`overlay_map_holder ${mapAnimation}`} >

                                <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                                <Common_title
                                    title={"CAMPUS DEAL "}
                                    subtitle={"Let's Get in Touch"}
                                />
                                <div className="row me-0 ms-0 justify-content-center align-items-center h-100">
                                    <div className="col-xl-6 col-md-8 col-sm-12">
                                        <div className="map_holder" style={{ position: 'relative' }}>

                                            <iframe
                                                width="100%"
                                                height="100%"
                                                frameBorder="0"
                                                scrolling="no"
                                                marginHeight="0"
                                                marginWidth="0"
                                                src="https://maps.google.com/maps?q=vidyan%20nagar&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                                title="Google Map"
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>

                                {/* ❌ Cross Icon */}
                                <span
                                    className='cross_icon'
                                    onClick={handleCloseMap}
                                >
                                    <FontAwesomeIcon icon={faXmark} />
                                </span>

                            </div>
                        </>
                    )}
                </div>
            </section >
        </>
    )
}

export default Contact
